/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlAdminGrantRequestsResponse } from './ControlAdminGrantRequestsResponse';
import {
    ControlAdminGrantRequestsResponseFromJSON,
    ControlAdminGrantRequestsResponseFromJSONTyped,
    ControlAdminGrantRequestsResponseToJSON,
} from './ControlAdminGrantRequestsResponse';

/**
 * 
 * @export
 * @interface ControlPaginatedAdminGrantRequestsResponse
 */
export interface ControlPaginatedAdminGrantRequestsResponse {
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedAdminGrantRequestsResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedAdminGrantRequestsResponse
     */
    page_size: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedAdminGrantRequestsResponse
     */
    count: number;
    /**
     * 
     * @type {Array<ControlAdminGrantRequestsResponse>}
     * @memberof ControlPaginatedAdminGrantRequestsResponse
     */
    results: Array<ControlAdminGrantRequestsResponse>;
}

/**
 * Check if a given object implements the ControlPaginatedAdminGrantRequestsResponse interface.
 */
export function instanceOfControlPaginatedAdminGrantRequestsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "page_size" in value;
    isInstance = isInstance && "count" in value;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ControlPaginatedAdminGrantRequestsResponseFromJSON(json: any): ControlPaginatedAdminGrantRequestsResponse {
    return ControlPaginatedAdminGrantRequestsResponseFromJSONTyped(json, false);
}

export function ControlPaginatedAdminGrantRequestsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPaginatedAdminGrantRequestsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': json['page'],
        'page_size': json['page_size'],
        'count': json['count'],
        'results': ((json['results'] as Array<any>).map(ControlAdminGrantRequestsResponseFromJSON)),
    };
}

export function ControlPaginatedAdminGrantRequestsResponseToJSON(value?: ControlPaginatedAdminGrantRequestsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': ((value.results as Array<any>).map(ControlAdminGrantRequestsResponseToJSON)),
    };
}

